"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityType = exports.BuyerInfoType = exports.FrequencyType = exports.IdentityType = void 0;
var IdentityType;
(function (IdentityType) {
    IdentityType["admin"] = "ADMIN";
    IdentityType["member"] = "MEMBER";
    IdentityType["visitor"] = "VISITOR";
    IdentityType["user"] = "USER";
    IdentityType["contact"] = "CONTACT";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
var FrequencyType;
(function (FrequencyType) {
    FrequencyType["day"] = "DAY";
    FrequencyType["week"] = "week";
    FrequencyType["month"] = "MONTH";
    FrequencyType["year"] = "YEAR";
    FrequencyType["undefined"] = "UNDEFINED";
})(FrequencyType = exports.FrequencyType || (exports.FrequencyType = {}));
var BuyerInfoType;
(function (BuyerInfoType) {
    BuyerInfoType["UNSPECIFIED_IDENTITY_TYPE"] = "UNSPECIFIED_IDENTITY_TYPE";
    BuyerInfoType["MEMBER"] = "MEMBER";
    BuyerInfoType["CONTACT"] = "CONTACT";
})(BuyerInfoType = exports.BuyerInfoType || (exports.BuyerInfoType = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["UNSPECIFIED_ORDER_HISTORY_ITEM_TYPE"] = "UNSPECIFIED_ORDER_HISTORY_ITEM_TYPE";
    ActivityType["MERCHANT_COMMENT"] = "MERCHANT_COMMENT";
    ActivityType["ORDER_PLACED"] = "ORDER_PLACED";
    ActivityType["ORDER_PAID"] = "ORDER_PAID";
    ActivityType["ORDER_FULFILLED"] = "ORDER_FULFILLED";
    ActivityType["ORDER_NOT_FULFILLED"] = "ORDER_NOT_FULFILLED";
    ActivityType["DOWNLOAD_LINK_SENT"] = "DOWNLOAD_LINK_SENT";
    ActivityType["PICKUP_READY_EMAIL_SENT"] = "PICKUP_READY_EMAIL_SENT";
    ActivityType["TRACKING_NUMBER_ADDED"] = "TRACKING_NUMBER_ADDED";
    ActivityType["TRACKING_NUMBER_EDITED"] = "TRACKING_NUMBER_EDITED";
    ActivityType["TRACKING_LINK_WAS_SET"] = "TRACKING_LINK_WAS_SET";
    ActivityType["SHIPPING_CONFIRMATION_EMAIL_SENT"] = "SHIPPING_CONFIRMATION_EMAIL_SENT";
    ActivityType["INVOICE_WAS_SET"] = "INVOICE_WAS_SET";
    ActivityType["INVOICE_WAS_REMOVED"] = "INVOICE_WAS_REMOVED";
    ActivityType["INVOICE_WAS_SENT"] = "INVOICE_WAS_SENT";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
//# sourceMappingURL=order.dto.js.map